import React, { Component } from 'react';
import { loadAsync } from 'Utils';
import Typography from 'Components/Typography';
import CallToAction from 'Components/CallToAction';
import { Container, Col, Row } from 'Components/Grid';
import styles from './styles.scss';
import RichText from 'Components/RichText';

declare var FMM_SNIPPET_BASE_URL_NEW: string;

export default class TopCars extends Component {
  componentDidMount() {
    // we don't reload the script if the remountSnippet is available
    if (window.remountSnippet) return window.remountSnippet();

    loadAsync(`${process.env.FMM_SNIPPET_BASE_URL_NEW}main.css`, true);
    loadAsync(`${process.env.FMM_SNIPPET_BASE_URL_NEW}main.js`, true, true, true);
  }

  render() {
    const { cta1, dealer, deeplinkId, fmmSnippet, headline, bodyText } = this.props;

    if (fmmSnippet?.query && dealer.settings?.customTopCars?.isActive) {
      return null;
    }

    return (
      <div id={deeplinkId} className={styles.fmmWrapper}>
        {(headline || bodyText) && (
          <Container className={styles.containerTop}>
            <Row align="center">
              <Col cols={12} m={10} l={8} align="center">
                  {headline && (
                    <Typography.Headline
                      {...headline}
                      className={styles.headline}
                      levelVisually="h3"
                    />
                  )}
                  {bodyText && <RichText content={bodyText} className={styles.bodyText} />}
              </Col>
            </Row>
          </Container>
        )}
        <div
          className="fmm-vehicle-snippet"
          data-dealerid={dealer.demodernDealerId}
          data-fmm-query={fmmSnippet.query}
          id="fmm-snippet"
        />
        {cta1 && (
          <Container className={styles.containerBottom}>
            <Row>
              <CallToAction
                {...cta1}
                className={styles.cta}
              />
            </Row>
          </Container>
        )}
      </div>
    );
  }
}
